import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    { path: 'home', loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule), data: { state: 'home' } },
    { path: 'about-us', loadChildren: () => import('./pages/about-us/about-us.module').then(m => m.AboutUsModule), data: { state: 'about-us' } },
    { path: 'team', loadChildren: () => import('./pages/team/team.module').then(m => m.TeamModule), data: { state: 'team' } },
    { path: 'managed-events', loadChildren: () => import('./pages/event-update/event-update.module').then(m => m.EventUpdateModule), data: { state: 'event-update' } },
    // tslint:disable-next-line:max-line-length
    { path: 'managed-artists', loadChildren: () => import('./pages/managed-artists/managed-artists.module').then(m => m.ManagedArtistsModule), data: { state: 'managed-artists' } },
    { path: 'contact-us', loadChildren: () => import('./pages/contact-us/contact-us.module').then(m => m.ContactUsModule), data: { state: 'contact-us' } },
    { path: 'content/:id', loadChildren: () => import('./pages/content/content.module').then(m => m.ContentModule), data: { state: 'content' } },
    { path: 'concert', loadChildren: () => import('./pages/concert/concert.module').then(m => m.ConcertModule), data: { state: 'concert'}}, 
    { path: "**", redirectTo: '/home' }
];


@NgModule({
    imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
